import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <CategoryGrid />
          <AboutSection />
          <FeaturesSection />
          <ArticlesSection />
          <CTASection />
        </article>
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Hipobuy Spreadsheet Hub",
            "url": "https://hipobuyspreads.store",
            "description": "The ultimate resource hub for smart shopping. Discover curated Hipobuy Spreadsheet resources, product research guides, comparison tools and expert shopping insights for global buyers.",
            "inLanguage": "en-US",
            "publisher": {
              "@type": "Organization",
              "name": "Hipobuy Spreadsheet Hub",
              "url": "https://hipobuyspreads.store",
              "logo": {
                "@type": "ImageObject",
                "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg"
              }
            },
            "potentialAction": {
              "@type": "SearchAction",
              "target": {
                "@type": "EntryPoint",
                "urlTemplate": "https://hipobuyspreads.store/search?q={search_term_string}"
              },
              "query-input": "required name=search_term_string"
            }
          })
        }}
      />
    </div>
  );
}